module.exports = __webpack_public_path__ + "img/27_20.9d30b118.png";